<div class="modalAjaxLoader">
  <div class="center">
    <img src="../../../../assets//spinner.gif" />
  </div>
</div>
